import { useContext } from "react";
import { colorPickerContext } from "../components/ColorPickerContextProvider/context.js";
function useColorPicker() {
  return useContext(colorPickerContext);
}
export {
  useColorPicker
};
//# sourceMappingURL=useColorPicker.js.map
